import React from "react";
import "./Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      {/* Glow background */}
      <div className="footer-glow footer-glow-1" />
      <div className="footer-glow footer-glow-2" />

      <div className="footer-inner">
        {/* Top section */}
        <div className="footer-top">
          {/* Brand / About */}
          <div className="footer-brand">
             <div className="logo-box">
            <img
              src="https://res.cloudinary.com/di82vlbpn/image/upload/v1764964487/ChatGPT_Image_Dec_6_2025_01_23_40_AM_i8bd26.png"
              alt="Logo"
              className="logo-img"
            />
            
          </div>
            <div>
              <h2 className="footer-title">Star Aluminium Works</h2>
              <p className="footer-tagline">
                Premium Aluminium & Glass Solutions for Homes & Offices
              </p>
            </div>
          </div>

          {/* Links */}
          <div className="footer-columns">
            <div className="footer-column">
              <h3>Company</h3>
              <ul>
                <li>
                  <a href="#about">About us</a>
                </li>
                <li>
                  <a href="#services">Services</a>
                </li>
                <li>
                  <a href="#projects">Projects</a>
                </li>
                <li>
                  <a href="#blog">Blog</a>
                </li>
              </ul>
            </div>

            <div className="footer-column">
              <h3>Support</h3>
              <ul>
                <li>
                  <a href="#contact">Contact</a>
                </li>
                <li>
                  <a href="#faq">FAQ</a>
                </li>
                <li>
                  <a href="#privacy">Privacy Policy</a>
                </li>
                <li>
                  <a href="#terms">Terms of use</a>
                </li>
              </ul>
            </div>

            <div className="footer-column">
              <h3>Contact</h3>
              <ul className="footer-contact">
                <li>
                  <span>📍</span> Uttar Pradesh
                </li>
                <li>
                  <span>📧</span> Staraluminium500@gmail.com
                </li>
                <li>
                  <span>📞</span> +91 9839586879
                </li>
                <li>
                  <span>📞</span> +91 9919604342
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="footer-divider" />

        {/* Bottom bar */}
        <div className="footer-bottom">
          <p className="footer-copy">
            © Star Aluminium Works | Since 2015 | All Rights Reserved.
          </p>

          <div className="footer-social">
            <a href="#" className="social-chip">
              <span className="social-dot" />
              Instagram
            </a>
            <a href="#" className="social-chip">
              <span className="social-dot" />
              LinkedIn
            </a>
            <a href="#" className="social-chip">
              <span className="social-dot" />
              YouTube
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
